import { render } from "./View.vue?vue&type=template&id=542aca59"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
script.render = render

export default script